import Vue from 'vue';
import {store} from './store';

// Vue Config settings
// Suppress Vue warning running in development mode
Vue.config.productionTip = false;
// turn on devtools -> requires browser extension: https://devtools.vuejs.org/guide/browser-extension
// Vue.config.devtools = process.env.NODE_ENV !== 'production';
// Vue.config.performance = process.env.NODE_ENV !== 'production';


/**
 * Mounts Vue components on elements with the 'vue-component' class.
 * @param root
 */
export function instantiateVueApp(root = document) {
    const elements = root.querySelectorAll('[data-vue]');

    elements.forEach(el => {

        // skip if already mounted
        if (el.__vue_instance__) return;

        // create Vue instance without render
        el.__vue_instance__ = new Vue({
            el,
            store
        });
    });
}
